<template>
  <div>
    <FormRole ref="form" @addSuccess="getList"/>
    <div class="groupButton">
      <AppButton customType="default" @click="addRole">新增角色</AppButton>
    </div>
    <BasicTable :tableData="tableData" :columns="columns" >
      <template v-slot:is_enable="{ item }">
        <el-checkbox v-if="item.role_id !== 1" v-model="item.is_enable" @change="enableRole(item)" ></el-checkbox>
      </template>
      <template v-slot:operate="{ item }">
        <AppButton v-if="item.role_id !== 1" size="small" type="primary" plain @click="editRole(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
        <AppButton v-if="item.role_id !== 1" size="small" type="primary" plain :asyncClick="removeRole(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
      </template>
    </BasicTable>
  </div>
</template>

<script>
import { RoleService } from '../../service/role.service';
import FormRole from './formRole';
import { MessageBox } from 'element-ui';
const columns = [
  { name: '角色Id', key: 'role_id' },
  { name: '角色名称', key: 'role_name' },
  { name: '描述', key: 'role_desc' },
  { name: '是否启用', key: 'is_enable', type: 'custom' },
  { name: '操作', key: 'operate', type: 'custom' },
];
  export default {
    name: 'role',
    components: { FormRole },
    data() {
      return {
        tableData: [],
        columns,
        fields: [],
      }
    },
    async created() {
      this.getList();
    },
    methods: {
      async getList() {
        const data = await RoleService.getList();
        this.tableData = data;
      },
      addRole() {
        this.$refs.form.open('add');
      },
      async editRole(data) {
        const roleData = await RoleService.detail(data.role_id);
        this.$refs.form.open('edit', roleData);
      },
      filter() {

      },
      removeRole(item) {
        return async () => {
          await MessageBox.confirm('确定要删除这个角色吗？', '删除角色');
          await RoleService.deleteRole(item.role_id);
          this.getList();
        }
      },
      enableRole(item) {
        RoleService.switchRoleStatus(item.role_id, item.is_enable ? 1 : 0);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>